/** InsCoder WANG.J 2026-07-21 B + Community testimonial carousel navigation. **/
document.querySelectorAll('[data-testimonial-section]').forEach((section) => {
  const track = section.querySelector('[data-testimonial-track]');
  if (!track) return;

  const slides = [...track.children];
  let index = 0;

  if (!slides.length) return;

  const nearestIndex = () => slides.reduce((closest, slide, slideIndex) => {
    const distance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
    const closestDistance = Math.abs(slides[closest].offsetLeft - track.offsetLeft - track.scrollLeft);
    return distance < closestDistance ? slideIndex : closest;
  }, 0);
  const updateProgress = () => {
    section.querySelectorAll('[data-testimonial-progress]').forEach((progress) => {
      progress.style.transform = `translateX(${(index / slides.length) * 100}%) scaleX(${1 / slides.length})`;
    });
  };
  const go = (next) => {
    index = (next + slides.length) % slides.length;
    track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    updateProgress();
  };

  section.querySelectorAll('[data-testimonial-prev]').forEach((button) => {
    button.addEventListener('click', () => go(nearestIndex() - 1));
  });
  section.querySelectorAll('[data-testimonial-next]').forEach((button) => {
    button.addEventListener('click', () => go(nearestIndex() + 1));
  });
  track.addEventListener('scroll', () => {
    index = nearestIndex();
    updateProgress();
  }, { passive: true });
  window.addEventListener('resize', () => {
    index = nearestIndex();
    updateProgress();
  });
  updateProgress();
});
/** InsCoder WANG.J 2026-07-21 E + Community testimonial carousel navigation. **/
